import { useQuery } from "@tanstack/react-query";
import { listCases } from "@/lib/api";
import { queryKeys } from "@/lib/cache/queryKeys";
import { staleTimes } from "@/lib/cache/staleTimes";

export function useCases() {
  return useQuery({
    queryKey: queryKeys.cases.all,
    queryFn: listCases,
    staleTime: staleTimes.cases,
    select: (data) => data?.cases || [],
  });
}
